export default "__VITE_ASSET__BDZIyM33__"